'use client';

const ADMIN_SESSION_HINT_KEY = 'admin:sessionKnown';

export function hasAdminSessionHint(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    return window.localStorage.getItem(ADMIN_SESSION_HINT_KEY) === '1';
  } catch {
    return false;
  }
}

export function setAdminSessionHint(): void {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(ADMIN_SESSION_HINT_KEY, '1');
  } catch {
    // Ignore storage failures; the admin routes still validate with the backend.
  }
}

export function clearAdminSessionHint(): void {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.removeItem(ADMIN_SESSION_HINT_KEY);
  } catch {
    // Ignore storage failures; this is only a public-header optimization hint.
  }
}
